import { useEffect, useState } from "react";
import { getLooker } from "../service/Looker.service"

export function useLooker(dashboard = "1") {
    const [url, setUrl] = useState(null);

    useEffect(() => {
        (async () => {
            const resp = await getLooker(dashboard);

            if (!resp.success) {
                console.error("No se generó correctamente la URL", resp.error);
                return;
            }

            const { url } = resp.payload;
            setUrl(url);
        })();
    }, []);

    return { url };
}
